import React, { useEffect, useRef, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { AnswerItem, QuestionValidationTypes, ReduxState } from 'interface';
import { QuestionSLPRef, SLPQuestionType } from '../../questions.index';
import SLPUCheckDropdown, { SLPDropDownOption, SLPDropDownRef } from 'utilities/slp/dropdown/dropdown.index';
import { extractTitle } from 'scripts/string';
import { createQuestionTitle } from '../questionsTypes.script';
import { __DropDownOption } from 'utilities/slp/dropdown/dropdown.interface';

const SLPListQuestion: React.ForwardRefRenderFunction<
    QuestionSLPRef,
    ConnectedProps<typeof connector> & SLPQuestionType
> = (props: ConnectedProps<typeof connector> & SLPQuestionType, ref) => {
    React.useImperativeHandle(ref, () => ({
        validate: (e?: boolean) => validate(e),
        submit: (e?: boolean) => onSubmit(e),
    }));
    const lang = props.lang.SLP.questionsTypes;
    const question = props.question;
    const inputRef = useRef<SLPDropDownRef>(null);
    const [items, setItems] = useState<SLPDropDownOption[]>([]);
    const [title, setTitle] = useState(question.title);
    const index = props.answerList?.findIndex((i) => i.question.id === question.id);
    const [defaultValue, setDefaultValue] = useState<SLPDropDownOption>();

    useEffect(() => {
        const temp: SLPDropDownOption[] = [];
        question.items
            ?.sort((a, b) => (a.order ? a.order : a.id) - (b.order ? b.order : b.id))
            .map((i) => temp.push({ title: i.title, payload: i.id, archive: i.archive, isHidden: i.is_hidden }));
        if (question.data_list?.contents) {
            question.data_list.contents.map((i) => temp.push({ title: i.value, payload: i.id /* + temp.length  */ }));
        }
        setItems(temp);
        if (index !== undefined && index > -1) {
            const value = props.answerList[index].value;
            if (value !== undefined && value.length > 0) {
                const item = temp.find((i) => i.title === value);
                if (item) setDefaultValue(item);
            }
        }
    }, [question]);

    const [hint, setHint] = useState(question.description);

    useEffect(() => {
        if (question.description)
            setHint(
                createQuestionTitle(
                    question.description,
                    props.answerList,
                    props.answer?.answerer_info,
                    props.form.indicators,
                ),
            );
        setTitle(
            createQuestionTitle(question.title, props.answerList, props.answer?.answerer_info, props.form.indicators),
        );
    }, [props.answerList]);

    function validate(e?: boolean) {
        if (question.is_required && !inputRef.current?.getValue()) {
            if (e) inputRef.current?.setError(lang.selectiveErr);
            return false;
        }
        return true;
    }

    function setAnswer(value?: SLPDropDownOption) {
        const data = [...props.answerList];
        if (value && validate()) {
            const response: AnswerItem = {
                question_items: [{ title: value.title, id: Number(value.payload), payload: Number(value.payload) }],
                question: props.question,
                id: new Date().getTime(),
                answer: props.answer?.id,
                // value: value.title,
            };
            if (index !== undefined && index > -1) data[index] = response;
            else data.push(response);
        } else if (index !== undefined && index > -1) data.splice(index, 1);
        props.setAnswerList(data);
    }

    function onSubmit(e?: boolean) {
        const value = inputRef.current?.getValue();
        if (value && validate(e) && props.answer)
            props.submit({
                question_items: [{ title: value.title, payload: Number(value.payload), id: Number(value.payload) }],
                // value: value.title,
                question: question,
                id: new Date().getTime(),
                created_at: new Date().toISOString(),
            });
    }

    return (
        <SLPUCheckDropdown
            color={props.form?.answer_color}
            labelColor={props.form?.question_color}
            hint={extractTitle(hint, false, false)}
            ref={inputRef}
            counter={props.counter}
            label={extractTitle(title, false, false)}
            image={question.image_file}
            options={
                question.validations &&
                question.validations.find((i) => i.title === QuestionValidationTypes.randomItems)
                    ? items.sort(() => 0.5 - Math.random())
                    : items
            }
            required={question.is_required}
            onChange={setAnswer}
            dir={props.form.direction}
            defaultValue={defaultValue}
        />
    );
};
const mapStateToProps = (state: ReduxState) => ({
    direction: state.direction,
    lang: state.lang,
});

const connector = connect(mapStateToProps, null, null, { forwardRef: true });
export default connector(React.forwardRef(SLPListQuestion));
